export default __webpack_public_path__ + "static/media/IMG-20210326-WA0029.306862d6.jpg";